

import React,{useEffect,useState} from 'react';

import './index.scss';
import MSGDialogue from '../../components/Dialogue';
import axios from 'axios'
import {APIurl} from '../../App';




export default function MemberDelete(props){

  const [loginmsg, setLogingmsg] = useState("");
  const [colors, setColors] = useState("");
  const [logging, setLogging] = useState(false);
  const [diaglogueID, setdiaglogueID] = useState("msg12");



    useEffect(() => {
          //eslint-disable-next-line no-restricted-globals
        if (confirm("Do you want to delete this Member?")) {
          //eslint-disable-next-line no-restricted-globals
          var id = location.href;
          id = id.split("id=");
          id  = id[1];
          axios.post(APIurl,{ 
            cmd: "memberdelete",
            id: id
            
            } )
            .then((response) => {
    
            var res = response.data;
            console.log(res);
            if(!res["success"]){
                setLogingmsg(res["data"]);
                setLogging(true);
                setColors(" text-white bg-danger");
            }
            else{
               
                setLogging(true);
               
                setColors(" text-white bg-success");
                setLogingmsg(res["data"]);

     
            }
           
            })
            .catch((error) => {
            console.log(error);
            })
          }
        
        setTimeout(()=>{
             //eslint-disable-next-line no-restricted-globals
             var BaseURL = location.href;
                BaseURL = BaseURL.split("/");
                BaseURL = BaseURL[0];
                  //eslint-disable-next-line no-restricted-globals
                location.href = BaseURL + "/dashboard";
            
        },
            2000
            )
      }, []);


        return(
            <>
          {logging? <MSGDialogue msg = {loginmsg} id = {diaglogueID}  colors= {colors} /> : ""}   
            </>
        )
        ;
    

  

}